import type { FC } from 'react'

import type { TIconProps } from 'types'

const ArrowIconRight: FC<TIconProps> = ({ className }) => (
  <svg className={className} width='10' height='20' viewBox='0 0 10 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.335647 19.7474C-0.0771358 19.3805 -0.114317 18.7484 0.252601 18.3356L7.66205 9.99999L0.252602 1.66435C-0.114316 1.25157 -0.077135 0.619497 0.335648 0.252579C0.748431 -0.114338 1.3805 -0.0771579 1.74742 0.335625L9.74742 9.33563C10.0842 9.71451 10.0842 10.2855 9.74742 10.6644L1.74742 19.6644C1.3805 20.0771 0.74843 20.1143 0.335647 19.7474Z'
      fill='#19191A'
    />
  </svg>
)

export default ArrowIconRight
